import { WifiOff } from "lucide-react";

// Shared fallback for any query that fails outright (backend unreachable,
// 5xx, etc.) — without this, a page that only branches on isLoading just
// silently renders its empty state when data never arrives, which reads
// as "there's nothing here" instead of "something's wrong, try again."
export default function ErrorState({ message = "Couldn't load this — check your connection.", onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <WifiOff size={32} className="text-mono/15" />
      <p className="mt-3 text-sm text-ink-light">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 rounded-xl border border-mono/10 px-4 py-2 text-xs text-ink-light hover:text-ink"
        >
          Try again
        </button>
      )}
    </div>
  );
}
